import { PostTipoCambioResponse } from "../../bussines/entities/PostTipoCambioResponse.entity";
import { paramsPostTipoCambio } from "../../bussines/params/addEditTipoCambio.params";
import { EditTipoCambioRepository } from "../../bussines/repository/EditTipoCambio.repository";
import { EditTipoCambioExpressProvider } from "../providers/EditTipoCambio.provider";


export class EditTipoCambioDatasource implements EditTipoCambioRepository {
    private EditTipoCambioProvider: EditTipoCambioExpressProvider;
    constructor(apikey:string) {
        this.EditTipoCambioProvider = new EditTipoCambioExpressProvider(apikey);
    }
    postEditTipoCambio(variables: paramsPostTipoCambio): Promise<PostTipoCambioResponse>{
        return this.EditTipoCambioProvider.postEditTipoCambio(variables);
    }
}